/**
 * Sound, as a setting rather than a button in a header.
 *
 * It lived on the avatar screen as a pill beside the logo, which put a
 * device-wide preference in the middle of choosing a name and a face — two
 * questions about you, and a third about the app. It belongs with the other
 * things you set once.
 *
 * A device preference, not a room one: it changes what *you* hear, and two
 * people at one table can reasonably want different answers. That is why it is
 * local state over `muted()` rather than anything the host sends.
 *
 * The switch reads "Sound" and is on when sound is on — the store underneath
 * records the opposite, and a switch labelled with the negative ("Muted: off")
 * is a thing to work out rather than read.
 */

import { useState } from 'react';
import { muted, setMuted } from '../render/sound.js';
import { SettingRow } from './SettingRow.js';

export function SoundSetting() {
  const [quiet, setQuiet] = useState(muted());

  return (
    <SettingRow
      icon={quiet ? 'speaker-off' : 'speaker'}
      title="Sound"
      help="Card taps, your turn, and the noise a face makes"
      checked={!quiet}
      onChange={(on) => {
        setQuiet(!on);
        setMuted(!on);
      }}
    />
  );
}
